export class Class {
	setOptions(defaultOptions, options){
		this.options = $.extend({}, defaultOptions, options);
	}
}


// WEBPACK FOOTER //
// ./Javascript/core/Abacus.Utilities.js